import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=735f550b&"
import script from "./Strategy.vue?vue&type=script&lang=ts&"
export * from "./Strategy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports